module.exports = {
      id: "hamburger-twitter-usage",
      viewBox: "0 0 36 37",
      url: __webpack_public_path__ + "svg-sprite-afa9d3605aa6d2fee8793cc86cfa3445.svg#hamburger-twitter",
      toString: function () {
        return this.url;
      }
    }